import React from 'react';

import { Event as CustomEvent } from '@yandex-int/messenger.utils';
import { useSelector } from 'react-redux';

import { SELF } from '../../../../shared/constants';
import { isMobileUa } from '../../../../shared/features/uatraits';
import { i18n } from '../../../../shared/helpers/i18n';
import { BroadcastStatus } from '../../../../types';
import { useParticipantModerationPopup } from '../../hooks/participant-moderation-popup';
import { getBroadcastStarterUid, getBroadcastStatus } from '../../selectors';
import { Participant, WaitingRoomPeerState } from '../../types';
import { EmptyStub } from '../empty-stub';
import { ParticipantComponent } from '../participants-list';
import { WaitingRoomPeer } from '../waiting-room-peers-list';

interface ParticipantsSearchResult {
    searchResult: (Participant | WaitingRoomPeerState)[];
}

const ParticipantsSearchResult = ({ searchResult }: ParticipantsSearchResult) => {
    const onParticipantListChanged = new CustomEvent();
    const broadcastStarterUid = useSelector(getBroadcastStarterUid);
    const broadcastStatus = useSelector(getBroadcastStatus);
    const isMobile = useSelector(isMobileUa);

    const { showModerationPopupId, openModerationPopup, closeModerationPopup } = useParticipantModerationPopup();

    if (searchResult.length === 0) {
        return (
            <EmptyStub
                title={i18n('participants-sidebar', 'participants-search-stub-title')}
                text={i18n('participants-sidebar', 'participants-search-stub-text')}
                imageName="participantsSearchStub"
            />
        );
    }

    return (
        <>
            {searchResult.map((participant) => {
                if ('waitingRoomEnteredAt' in participant) {
                    return <WaitingRoomPeer key={participant.id} peer={participant as WaitingRoomPeerState} />;
                } else {
                    const { id, uid, isLocalRecording } = participant;
                    const isBroadcasting = broadcastStatus === BroadcastStatus.STARTED && broadcastStarterUid === uid;
                    return (
                        <ParticipantComponent
                            key={participant.id}
                            participant={participant as Participant}
                            showModerationPopup={id === showModerationPopupId && id !== SELF}
                            showRecordingIcon={isLocalRecording && id !== SELF}
                            showBroadcastIcon={isBroadcasting && id !== SELF}
                            openModerationPopup={() => openModerationPopup(id)}
                            closeModerationPopup={closeModerationPopup}
                            isMobile={isMobile}
                            onParticipantListChanged={onParticipantListChanged}
                        />
                    );
                }
            })}
        </>
    );
};

export { ParticipantsSearchResult };
